import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';

import Header from '../../components/Header';
import PromoBanner from '../../components/PromoBanner';
import SmallLoader from '../../components/Loaders/SmallLoader';
import TermsModal from '../../components/TermsModal';
import { login, SendOtpAPI } from '../../http/http';

import classes from './PromoAuth.module.css';
import { setUserToken } from '../../store/slices/userTokenSlice';
import { useTranslation } from 'react-i18next';
import { FaArrowLeft } from 'react-icons/fa6';
import OnboardingPage from '../OnboardingPage';

const PromoAuth = () => {
    const [msisdn, setMsisdn] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [extRef, setExtRef] = useState(null);
    const [termsModal, setTermsModal] = useState(false);

    const [showOnboarding, setShowOnboarding] = useState(true);


    const { t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const inputRef = useRef(null);

    const dispatch = useDispatch();

    const { userToken } = useSelector(state => state.persisted.userTokenSlice);

    useEffect(() => {
        if (searchParams.get('ext_ref')) {
            setExtRef(searchParams.get('ext_ref'));
        } else {
            setSearchParams({ ext_ref: uuidv4().substring(0, 25) });
        }
    }, [searchParams]);

    const handleChange = (e) => {
        const value = e.target.value;
        setMsisdn(value);
        if (error) setError('');
    };

    const handleFormSubmission = async (e) => {
        e.preventDefault();

        try {
            if (msisdn?.trim().length == 0) {
                return;
            }

            setLoading(true);

            await login({ msisdn: msisdn })
                .then((res) => {
                    setLoading(false);
                    dispatch(setUserToken(res?.data?.result?.token));
                    console.log("/promo/home");
                    window.location.href = '/promo/home';
                    toast.success(t("84"));
                })
                .catch((err) => {
                    setLoading(false);
                    if (err?.response?.data?.error?.status == 1) {
                        navigate("/low-balance");
                    }
                    else {
                        navigate('/promo/select-packs', {
                            state: {
                                msisdn,
                                extRef,
                                pack: 'Daily',
                            }
                        });
                    }
                });

        } catch (err) {

            setLoading(false);
            toast.error(t("86"));
        }
    };

    return (
        <>

            {showOnboarding ? (
                <OnboardingPage onNext={() => setShowOnboarding(false)} />
            ) : (
                <>
                    {/* <Header />

                    <div className={classes.container}>

                        <div className={classes.header_section}>
                            <div className={classes.back_button} onClick={() => {
                                navigate("/");
                            }}>
                                <FaArrowLeft className={classes.back_icon} />
                            </div>
                        </div>

                        <PromoBanner
                            showContinue={false}
                        />

                        <div className={classes.intro}>
                            <h1 className={classes.heading}>{t("143")}</h1>
                            <p className={classes.sub_heading}>
                                {t("144")}
                            </p>
                        </div>

                        <form className={classes.form} onSubmit={handleFormSubmission}>
                            <label htmlFor="msisdn" className={classes.field_label}>
                                {t("145")}
                            </label>

                            <div className={classes.username_field_form}>
                                <div className={classes.country_code}>
                                    <img
                                        src="/assets/images/congo.png"
                                        alt="Congo flag"
                                        className={classes.flag}
                                    />
                                    <p className={classes.country_code_number}>+242</p>
                                </div>
                                <input
                                    id="msisdn"
                                    name="msisdn"
                                    type="tel"
                                    inputMode="numeric"
                                    autoComplete="tel-national"
                                    ref={inputRef}
                                    autoFocus
                                    placeholder="06 000 0000"
                                    className={`${classes.input_field_username} ${error ? classes.input_error : ''}`}
                                    onChange={handleChange}
                                    value={msisdn}
                                />
                            </div>

                            {error && <p className={classes.error_text}>{error}</p>}

                            <button
                                type="submit"
                                disabled={loading}
                                className={classes.continue_btn}
                            >
                                {loading
                                    ? <SmallLoader style={{ border: '5px solid #fff' }} />
                                    : t("146")}
                            </button>

                            <p className={classes.terms_text}>
                                {t("147")}{' '}
                                <span
                                    className={classes.link}
                                    onClick={() => setTermsModal(true)}
                                >
                                    {t("148")}
                                </span>
                                {t("149")}
                            </p>

                            <div className={classes.footer}>
                                <p>
                                    <span>&copy;</span> Rainboo Softmate{' '}
                                    {new Date().getFullYear()}
                                </p>
                            </div>
                        </form>
                    </div> */}

                    <Header />

                    <div className={classes.page}>



                        <img
                            src="/assets/images/subscription-page.png"
                            alt=""
                            className={classes.hero}
                            draggable={false}
                        />

                        <div className={classes.card}>

                            <div className={classes.header_section}>
                                <div className={classes.back_button} onClick={() => {
                                    navigate("/");
                                }}>
                                    <FaArrowLeft className={classes.back_icon} />
                                </div>

                            </div>

                            <h1 className={classes.title_main}>
                                {t("158")}
                            </h1>

                            <p className={classes.title_sub}>
                                {t("159")}
                            </p>

                        </div>

                        <div className={classes.gap}>

                            {/* <PromoBanner showContinue={true} /> */}

                            <h1 className={classes.input_text}>{t("160")}</h1>

                            <form className={classes.form} onSubmit={handleFormSubmission}
                            >
                                <div className={classes.username_field_form}>
                                    <div className={classes.country_code}>
                                        <img src="/assets/images/congo.png" alt="flag" className={classes.flag} />
                                        <p className={classes.country_code_number}>+242</p>
                                    </div>
                                    <input
                                        id="msisdn"
                                        name="msisdn"
                                        type="number"
                                        onWheel={(e) => e.target.blur()}
                                        autoFocus placeholder={"06 000 00 00"} className={classes.input_field_username}
                                        onChange={(e) => {
                                            setMsisdn(e.target.value)
                                        }}
                                        value={msisdn}
                                    />
                                </div>

                                <div className={classes.check_box_container}>
                                    <input type="checkbox" id="terms" name="Terms & Conditions" value="Terms"
                                        className={classes.check_box} checked
                                    >
                                    </input>
                                    <label for="terms" className={classes.check_box_label}>
                                        {t("157")}{" "}<span className={classes.link} onClick={() => setTermsModal(true)}>{t("114")}</span>
                                    </label>
                                </div>

                                <button type="submit"
                                    disabled={loading}
                                    className={classes.login_btn}>{
                                        loading ? <SmallLoader style={{ border: "5px solid #fff" }} /> : t("156")
                                    }</button>
                                <div className={classes.footer}>
                                    <p><span>&copy;</span> Rainboo Softmate {new Date().getFullYear()}</p>
                                </div>
                            </form>

                        </div>
                    </div >

                    {termsModal && <TermsModal setTermsModal={setTermsModal} />
                    }
                </>
            )}
        </>
    );
};

export default PromoAuth;